<p-popover #workoutJobsOverlay [dismissable]="true" [appendTo]="'body'"
  [style]="{ 'min-width': '18rem', 'max-width': '22rem' }">
  <ng-template #content>
    <div class="p-2 max-h-[28rem] overflow-y-auto">
      <!-- Header -->
      <div class="flex items-center justify-between px-2 pb-2 border-b border-grey-100 mb-2">
        <span class="text-sm font-semibold text-grey-900">Generation Plans</span>
        <span class="text-xs text-grey-400">Last 24 hours</span>
      </div>

      @if (workoutJobsStateService.jobs().length === 0) {
        <div class="flex flex-col items-center justify-center p-6 text-center">
          <span class="pi pi-bolt text-2xl text-grey-300 mb-2"></span>
          <p class="text-sm font-medium text-grey-600 mb-1">No recent plans </p>
          <p class="text-xs text-grey-400">Workout plan generation will appear here</p>
        </div>
      } @else {
        <div class="flex flex-col gap-1">
          @for (job of workoutJobsStateService.jobs(); track job.jobId) {
            <div
              class="flex items-center gap-3 p-2 rounded-lg transition-colors"
              [class.cursor-pointer]="isJobClickable(job)"
              [class.hover:bg-grey-50]="isJobClickable(job)"
              [class.opacity-60]="job.status === 'Cancelled'"
              (click)="onJobClick(job)">

              <!-- Status Icon -->
              <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center"
                [ngClass]="{
                  'bg-primary-50': isJobActive(job),
                  'bg-green-50': job.status === 'Completed',
                  'bg-red-50': job.status === 'Failed',
                  'bg-grey-100': job.status === 'Cancelled'
                }">
                @if (isJobActive(job)) {
                  <span class="pi pi-spin pi-spinner text-primary-600 text-sm"></span>
                } @else if (job.status === 'Completed') {
                  <span class="pi pi-check text-green-600 text-sm"></span>
                } @else if (job.status === 'Failed') {
                  <span class="pi pi-times text-red-500 text-sm"></span>
                } @else {
                  <span class="pi pi-ban text-grey-400 text-sm"></span>
                }
              </div>

              <!-- Client Info -->
              <div class="flex-1 min-w-0">
                <p class="text-[0.8rem] font-medium text-grey-900 truncate">
                  {{ job.client.firstName }} {{ job.client.lastName }}
                </p>
                <div class="flex items-center gap-2 mt-0.5">
                  <p class="text-[0.7rem] leading-none"
                    [ngClass]="{
                      'text-primary-600': isJobActive(job),
                      'text-grey-400': job.status === 'Completed' || job.status === 'Cancelled',
                      'text-red-500': job.status === 'Failed',
                    }">
                    {{ getJobStatusLabel(job.status) }}
                  </p>
                  @if (isJobActive(job)) {
                    <span class="text-[0.65rem] text-grey-300">•</span>
                    <p class="text-[0.65rem] text-primary-600 leading-none font-medium tabular-nums">
                      {{ workoutJobsStateService.jobDurationsFormatted().get(job.jobId) }}
                    </p>
                  } @else if (job.durationInSeconds > 0) {
                    <span class="text-[0.65rem] text-grey-300">·</span>
                    <span
                      class="text-[0.65rem] text-grey-400 leading-none tabular-nums"
                      pTooltip="Generation time"
                      tooltipPosition="bottom"
                      tooltipStyleClass="small-tooltip">
                      {{ formatElapsedDuration(job.durationInSeconds) }}
                    </span>
                  }
                </div>
              </div>

              <!-- Action Buttons -->
              @if (permissionService.canAddWorkoutPlan()) {
                <div class="flex-shrink-0 flex items-center gap-1" (click)="$event.stopPropagation()">
                  @if (isJobActive(job)) {
                    <button
                      (click)="onCancelJob($event, job)"
                      class="flex items-center justify-center w-7 h-7 rounded-lg border border-red-200 text-red-500 hover:bg-red-50 transition-colors text-xs"
                      pTooltip="Cancel"
                      tooltipPosition="bottom"
                      tooltipStyleClass="small-tooltip">
                      <span class="pi pi-times text-[0.65rem]"></span>
                    </button>
                  }
                  @if (job.status === 'Failed') {
                    <button
                      (click)="onRetryJob($event, job)"
                      class="flex items-center justify-center w-7 h-7 rounded-lg border border-primary-200 text-primary-600 hover:bg-primary-50 transition-colors text-xs"
                      pTooltip="Retry"
                      tooltipPosition="bottom"
                      tooltipStyleClass="small-tooltip">
                      <span class="pi pi-refresh text-[0.65rem]"></span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</p-popover>
